const sportCastConfig = {
  WIDGET_KEY: "4148833c-e969-4b6f-9299-b693dc74340e",
};

export default sportCastConfig;